import {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {Button, Checkbox, Input, Popconfirm, Radio, Select, Table} from "antd";
import {Menu as MENU, Trash2, X} from "react-feather";
import SideMenuBar from "./components/SideMenuBar";
import {toast} from "react-toastify";
import API_LINK from "../components/links/Link";
import $ from "jquery";

export default function AddWall() {
    const location = useLocation();
    const history = useHistory();
    const [isMobileShow, setIsMobileShow] = useState(false);
    // States for each form input
    const [wallSelection, setWallSelection] = useState('');
    const [fireResistance, setFireResistance] = useState('');
    const [acousticRating, setAcousticRating] = useState({type: 'Rw', value: ''});
    const [maxWidth, setMaxWidth] = useState('');
    const [pressure, setPressure] = useState('');
    const [height, setHeight] = useState('');
    const [studWidth, setStudWidth] = useState('');
    const [attributes, setAttributes] = useState({
        impactResistance: {oneSide: false, otherSide: false},
        moistureResistance: {oneSide: false, otherSide: false},
        mouldResistance: {oneSide: false, otherSide: false},
        notRequired: false,
    });
    const [systemNo, setSystemNo] = useState('');
    const [lining, setLining] = useState({lining1: '', lining2: '', lining3: ''});

    const handleAttributeChange = (attribute, side, checked) => {
        setAttributes({
            ...attributes,
            [attribute]: {...attributes[attribute], [side]: checked},
        });
    };

    // DataTables
    const [ref, setRef] = useState('')
    const [sideOne, setSideOne] = useState('')
    const [sideTwo, setSideTwo] = useState('')
    const [masonry, setMasonry] = useState('')
    const [insulation, setInsulation] = useState('')
    const [rval, setRval] = useState('')

    const [wallsData, setWallsData] = useState([]);
    const [wallName, setWallName] = useState('');

    useEffect(() => {
        LoadWalls();
    }, []);
    const LoadWalls = async () => {
        try {
            let formdata = new FormData();
            formdata.append("page", "GetWallName");
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Walls.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result)
                    if (result.status === 1) {
                        if (result.data.length > 0) {
                            setWallsData(result.data);
                        }
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                }).catch(error => console.log('error', error));
        } catch (e) {
            console.log(e)
        }
    }


    // For Update Purpose
    const [updateId, setUpdateId] = useState('');
    // If Update
    useEffect(() => {
        const WallRecord = location.state?.data;
        if (WallRecord) {
            setUpdateId(WallRecord.id)
            setWallSelection(WallRecord.Wall);
            setFireResistance(WallRecord.FireResistance);
            let acoustic = WallRecord.AcousticRating;
            acoustic = acoustic.split(' ');
            setAcousticRating({type: acoustic[0], value: acoustic[1]});
            setMaxWidth(WallRecord.SystemWidth)
            setPressure(WallRecord.Pressure)
            setHeight(WallRecord.WallHeight)
            setStudWidth(WallRecord.StudWidth)
            setAttributes({
                impactResistance: {
                    oneSide: WallRecord.ImpactResistance_one === 'true',
                    otherSide: WallRecord.ImpactResistance_other === 'true'
                },
                mouldResistance: {
                    oneSide: WallRecord.MouldResistance_one === 'true',
                    otherSide: WallRecord.MouldResistance_other === 'true'
                },
                moistureResistance: {
                    oneSide: WallRecord.MoistureResistance_one === 'true',
                    otherSide: WallRecord.MoistureResistance_other === 'true'
                },
            })
            setSystemNo(WallRecord.SystemNo)
            setLining({
                lining1: WallRecord.FirstLining,
                lining2: WallRecord.SecondLining,
                lining3: WallRecord.ThirdLining,
            })
            setRef(WallRecord.Ref)
            setSideOne(WallRecord.SideOne)
            setSideTwo(WallRecord.SideTwo)
            setMasonry(WallRecord.Masonry)
            setInsulation(WallRecord.Insulation)
            setRval(WallRecord.RVal)
        }
    }, []);

    const submitHandle = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        try {
            var form = $('.SubmitForm');
            if (!form[0].checkValidity()) {
                toast.warn("Fill all the required(*) fields.")
            } else {
                const wallData = {
                    page: "SaveWall",
                    Wall: wallSelection,
                    FireResistance: fireResistance,
                    AcousticRating: `${acousticRating.type} ${acousticRating.value}`, // Combine type and value
                    SystemWidth: maxWidth,
                    Pressure: pressure,
                    WallHeight: height,
                    StudWidth: studWidth,
                    ImpactResistance_one: attributes.impactResistance.oneSide,
                    ImpactResistance_other: attributes.impactResistance.otherSide,
                    MoistureResistance_one: attributes.moistureResistance.oneSide,
                    MoistureResistance_other: attributes.moistureResistance.otherSide,
                    MouldResistance_one: attributes.mouldResistance.oneSide,
                    MouldResistance_other: attributes.mouldResistance.otherSide,
                    SystemNo: systemNo,
                    FirstLining: lining.lining1,
                    SecondLining: lining.lining2,
                    ThirdLining: lining.lining3,
                    Ref: ref,
                    SideOne: sideOne,
                    SideTwo: sideTwo,
                    Masonry: masonry,
                    Insulation: insulation,
                    RVal: rval,
                };
                const formData = new FormData();
                if (updateId) {
                    formData.append("id", updateId);
                    formData.append("page", "UpdateWall");
                } else
                    formData.append("page", "SaveWall");
                formData.append("Wall", wallData.Wall);
                formData.append("FireResistance", wallData.FireResistance);
                formData.append("AcousticRating", wallData.AcousticRating);
                formData.append("SystemWidth", wallData.SystemWidth);
                formData.append("Pressure", wallData.Pressure);
                formData.append("WallHeight", wallData.WallHeight);
                formData.append("StudWidth", wallData.StudWidth);
                formData.append("ImpactResistance_one", wallData.ImpactResistance_one);
                formData.append("ImpactResistance_other", wallData.ImpactResistance_other);
                formData.append("MoistureResistance_one", wallData.MoistureResistance_one);
                formData.append("MoistureResistance_other", wallData.MoistureResistance_other);
                formData.append("MouldResistance_one", wallData.MouldResistance_one);
                formData.append("MouldResistance_other", wallData.MouldResistance_other);
                formData.append("SystemNo", wallData.SystemNo);
                formData.append("FirstLining", wallData.FirstLining);
                formData.append("SecondLining", wallData.SecondLining);
                formData.append("ThirdLining", wallData.ThirdLining);
                formData.append("Ref", wallData.Ref);
                formData.append("SideOne", wallData.SideOne);
                formData.append("SideTwo", wallData.SideTwo);
                formData.append("Masonry", wallData.Masonry);
                formData.append("Insulation", wallData.Insulation);
                formData.append("RVal", wallData.RVal);

                try {
                    let toaster;
                    form.find("button").attr("disabled", true);
                    toaster = toast.loading("Processing...");
                    await fetch(`${API_LINK}Walls.php`, {
                        method: 'POST',
                        body: formData,
                        redirect: "follow",
                    })
                        .then(response => response.json())
                        .then(result => {
                            console.log(result);
                            if (result.status === 1) {
                                setTimeout(() => {
                                    toast.update(toaster, {
                                        type: "success",
                                        render: "You have successfully added a new wall.",
                                        isLoading: false,
                                        autoClose: toaster,
                                        closeButton: true,
                                        pauseOnHover: false,
                                        pauseOnFocusLoss: false,
                                        closeOnClick: true,
                                    })
                                    form.find("button").attr("disabled", false);
                                    form.trigger("reset");
                                    setTimeout(() => {
                                        history.goBack();
                                    }, 1500)
                                }, 1000)
                            }
                        })
                    form.find("button").attr("disabled", false);
                } catch (error) {
                    console.error('Error in the fetch request:', error);
                }
            }
        } catch (e) {
            console.log(e)
        }
    }

    return (<>
        <div className='dashboard-container'>
            <SideMenuBar mobileShow={isMobileShow}/>
            <div className="dashboard-content" data-aos={'fade-left'}>
                <form className='SubmitForm' onSubmit={submitHandle}>
                    <div className="content">
                        <button type={"button"} className='btn_dashboard_menu' onClick={() => setIsMobileShow(true)}>
                            <MENU size={16}/>
                            <span>Show Menu</span>
                        </button>
                        <button type={"button"} className={`btn_dashboard_close_menu ${isMobileShow ? "show" : "hide"}`}
                                onClick={() => setIsMobileShow(false)}>
                            <X size={16}/>
                        </button>
                        <h2>Add Wall</h2>
                        <span>want to add more wall?</span>

                        <div className="content-card">
                            <div className="table-search">
                                <button type={"button"} className='btn-card-header'
                                        onClick={() => history.goBack()}>Back To Walls
                                </button>
                            </div>
                            <div className="row">
                                {/* Wall Selection */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Select Wall</label>
                                        <select name="wall" value={wallSelection} required
                                                onChange={event => setWallSelection(event.target.value)}>
                                            <option value={''} disabled selected>Select...</option>
                                            {/*<option value="STEEL STUDS – LINED ONE SIDE">STEEL STUDS – LINED ONE SIDE*/}
                                            {/*</option>*/}
                                            {
                                                wallsData.map((w, index) => {
                                                    return (
                                                        <option key={index} value={w.Name}>{w.Name}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>

                                {/* Fire Resistance Level */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Fire Resistance Level</label>
                                        <select name="fireResistance" value={fireResistance} required
                                                onChange={event => setFireResistance(event.target.value)}>
                                            <option value={''} selected disabled>Select ...</option>
                                            <option value="-/-/-">-/-/-</option>
                                            <option value="-/30/30">-/30/30</option>
                                            <option value="-/60/60">-/60/60</option>
                                            <option value="-/90/90">-/90/90</option>
                                            <option value="-/120/120">-/120/120</option>
                                            <option value="≥ -/180/180">≥ -/180/180</option>
                                            <option value="30/30/30">30/30/30</option>
                                            <option value="60/60/60">60/60/60</option>
                                            <option value="90/90/90">90/90/90</option>
                                            <option value="120/120/120">120/120/120</option>
                                            <option value="≥ 180/180/180">≥ 180/180/180</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Acoustic Rating */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Acoustic Rating</label>
                                        <div className="row">
                                            <Radio.Group
                                                defaultValue="Rw"
                                                value={acousticRating.type}
                                                onChange={(e) =>
                                                    setAcousticRating({
                                                        ...acousticRating,
                                                        type: e.target.value,
                                                    })
                                                }
                                            >
                                                <Radio value="Rw">Rw</Radio>
                                                <Radio value="Rw+Ctr">Rw+Ctr</Radio>
                                            </Radio.Group>
                                            <input type="number" value={acousticRating.value} required
                                                   onChange={(e) => setAcousticRating({
                                                       ...acousticRating,
                                                       value: e.target.value
                                                   })} style={{width: "20%"}}/>
                                        </div>
                                    </div>
                                </div>

                                {/* Max System Width / Tile Width */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Max System Width / Tile Width (mm)</label>
                                        <input type="text" value={maxWidth} required
                                               onChange={(e) => setMaxWidth(e.target.value)}/>
                                    </div>
                                </div>

                                {/* Wall/Ceiling Pressure */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Wall/Ceiling Pressure</label>
                                        {/*<select name="wallCeilingPressure" value={pressure} required*/}
                                        {/*        onChange={event => setPressure(event.target.value)}>*/}
                                        {/*    <option value="0.00kPa - Ceilings Only">0.00kPa - Ceilings Only</option>*/}
                                        {/*    <option value="0.25kPa" selected>0.25kPa</option>*/}
                                        {/*    <option value="0.35kPa - Walls Only">0.35kPa - Walls Only</option>*/}
                                        {/*</select>*/}
                                        <input type={"text"}
                                               value={pressure} name={'wallCeilingPressure'}
                                               onChange={(e) => setPressure(e.target.value)}
                                        />
                                    </div>
                                </div>

                                {/* Wall Height / Ceiling Span */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Wall Height / Ceiling Span (mm)</label>
                                        <input type={"text"} required
                                               value={height}
                                               onChange={(e) => setHeight(e.target.value)}
                                        />
                                    </div>
                                </div>

                                {/* Stud Width */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Stud Width</label>
                                        <select value={studWidth} required
                                                onChange={(value) => setStudWidth(value.target.value)}>
                                            <option value={''} disabled selected>Select ...</option>
                                            <option value="51">51</option>
                                            <option value="64">64</option>
                                            <option value="70/76">70/76</option>
                                            <option value="90/92/102">90/92/102</option>
                                            <option value="150">150</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Attributes */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Attributes</label>
                                        <div>
                                            <Checkbox
                                                checked={attributes.impactResistance.oneSide}
                                                onChange={(e) => handleAttributeChange('impactResistance', 'oneSide', e.target.checked)}
                                            >
                                                Impact Resistance (One Side)
                                            </Checkbox>
                                            <Checkbox
                                                checked={attributes.impactResistance.otherSide}
                                                onChange={(e) => handleAttributeChange('impactResistance', 'otherSide', e.target.checked)}
                                            >
                                                Impact Resistance (Other Side)
                                            </Checkbox>
                                            <Checkbox
                                                checked={attributes.moistureResistance.oneSide}
                                                onChange={(e) => handleAttributeChange('moistureResistance', 'oneSide', e.target.checked)}
                                            >
                                                Moisture Resistance (One Side)
                                            </Checkbox>
                                            <Checkbox
                                                checked={attributes.moistureResistance.otherSide}
                                                onChange={(e) => handleAttributeChange('moistureResistance', 'otherSide', e.target.checked)}
                                            >
                                                Moisture Resistance (Other Side)
                                            </Checkbox>
                                            <Checkbox
                                                checked={attributes.mouldResistance.oneSide}
                                                onChange={(e) => handleAttributeChange('mouldResistance', 'oneSide', e.target.checked)}
                                            >
                                                Mould Resistance (One Side)
                                            </Checkbox>
                                            <Checkbox
                                                checked={attributes.mouldResistance.otherSide}
                                                onChange={(e) => handleAttributeChange('mouldResistance', 'otherSide', e.target.checked)}
                                            >
                                                Mould Resistance (Other Side)
                                            </Checkbox>
                                            <Checkbox
                                                checked={attributes.notRequired}
                                                onChange={(e) => setAttributes({
                                                    ...attributes,
                                                    notRequired: e.target.checked
                                                })}
                                            >
                                                Not Required
                                            </Checkbox>
                                        </div>
                                    </div>
                                </div>

                                {/* System No */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>System No.</label>
                                        <input type={'text'}
                                               value={systemNo} required
                                               onChange={(e) => setSystemNo(e.target.value)}
                                               placeholder="e.g. SB60.1A"
                                        />
                                    </div>
                                </div>

                                {/* Lining Options */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>First Lining</label>
                                        <select value={lining.lining1} required
                                                onChange={(value) => setLining({
                                                    ...lining,
                                                    lining1: value.target.value
                                                })}>
                                            <option value="" selected disabled>Select 1st Lining</option>
                                            <option value="SHEETROCK®">SHEETROCK®</option>
                                            <option value="Wetstop®">Wetstop®</option>
                                            <option value="Firestop®/Fire Wetstop™">Firestop®/Fire Wetstop™</option>
                                            <option value="FIBEROCK®">FIBEROCK®</option>
                                            <option value="Multistop™">Multistop™</option>
                                            <option value="Soundstop®">Soundstop®</option>
                                            <option value="Shaftliner™ MS">Shaftliner™ MS</option>
                                            <option value="Permarock®">Permarock®</option>
                                            <option value="Villaboard®">Villaboard®</option>
                                            <option value="10mm SHEETROCK® ONE">10mm SHEETROCK® ONE</option>
                                            <option value="13mm SHEETROCK® HD">13mm SHEETROCK® HD</option>
                                            <option value="10mm Wetstop®">10mm Wetstop®</option>
                                            <option value="13mm Wetstop®">13mm Wetstop®</option>
                                            <option value="13mm Firestop®/Fire Wetstop™">13mm Firestop®/Fire Wetstop™
                                            </option>
                                            <option value="16mm Firestop®/Fire Wetstop™">16mm Firestop®/Fire Wetstop™
                                            </option>
                                            <option value="13mm FIBEROCK®">13mm FIBEROCK®</option>
                                            <option value="16mm FIBEROCK®">16mm FIBEROCK®</option>
                                            <option value="13mm Multistop™">13mm Multistop™</option>
                                            <option value="16mm Multistop™">16mm Multistop™</option>
                                            <option value="10mm Soundstop®">10mm Soundstop®</option>
                                            <option value="13mm Soundstop®">13mm Soundstop®</option>
                                            <option value="25mm Shaftliner™ MS">25mm Shaftliner™ MS</option>
                                            <option value="12.5mm Permarock®">12.5mm Permarock®</option>
                                            <option value="6mm Villaboard®">6mm Villaboard®</option>
                                            <option value="10mm">10mm</option>
                                            <option value="13mm">13mm</option>
                                            <option value="16mm">16mm</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Second Lining</label>
                                        <select value={lining.lining2} required
                                                onChange={(value) => setLining({
                                                    ...lining,
                                                    lining2: value.target.value
                                                })}>
                                            <option value="" selected disabled>Select 2nd Lining</option>
                                            <option value="SHEETROCK®">SHEETROCK®</option>
                                            <option value="Wetstop®">Wetstop®</option>
                                            <option value="Firestop®/Fire Wetstop™">Firestop®/Fire Wetstop™</option>
                                            <option value="FIBEROCK®">FIBEROCK®</option>
                                            <option value="Multistop™">Multistop™</option>
                                            <option value="Soundstop®">Soundstop®</option>
                                            <option value="Shaftliner™ MS">Shaftliner™ MS</option>
                                            <option value="Permarock®">Permarock®</option>
                                            <option value="Villaboard®">Villaboard®</option>
                                            <option value="10mm SHEETROCK® ONE">10mm SHEETROCK® ONE</option>
                                            <option value="13mm SHEETROCK® HD">13mm SHEETROCK® HD</option>
                                            <option value="10mm Wetstop®">10mm Wetstop®</option>
                                            <option value="13mm Wetstop®">13mm Wetstop®</option>
                                            <option value="13mm Firestop®/Fire Wetstop™">13mm Firestop®/Fire Wetstop™
                                            </option>
                                            <option value="16mm Firestop®/Fire Wetstop™">16mm Firestop®/Fire Wetstop™
                                            </option>
                                            <option value="13mm FIBEROCK®">13mm FIBEROCK®</option>
                                            <option value="16mm FIBEROCK®">16mm FIBEROCK®</option>
                                            <option value="13mm Multistop™">13mm Multistop™</option>
                                            <option value="16mm Multistop™">16mm Multistop™</option>
                                            <option value="10mm Soundstop®">10mm Soundstop®</option>
                                            <option value="13mm Soundstop®">13mm Soundstop®</option>
                                            <option value="25mm Shaftliner™ MS">25mm Shaftliner™ MS</option>
                                            <option value="12.5mm Permarock®">12.5mm Permarock®</option>
                                            <option value="6mm Villaboard®">6mm Villaboard®</option>
                                            <option value="10mm">10mm</option>
                                            <option value="13mm">13mm</option>
                                            <option value="16mm">16mm</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Third Lining</label>
                                        <select value={lining.lining3} required
                                                onChange={(value) => setLining({
                                                    ...lining,
                                                    lining3: value.target.value
                                                })}>
                                            <option value="" selected disabled>Select 3rd Lining</option>
                                            <option value="SHEETROCK®">SHEETROCK®</option>
                                            <option value="Wetstop®">Wetstop®</option>
                                            <option value="Firestop®/Fire Wetstop™">Firestop®/Fire Wetstop™</option>
                                            <option value="FIBEROCK®">FIBEROCK®</option>
                                            <option value="Multistop™">Multistop™</option>
                                            <option value="Soundstop®">Soundstop®</option>
                                            <option value="Shaftliner™ MS">Shaftliner™ MS</option>
                                            <option value="Permarock®">Permarock®</option>
                                            <option value="Villaboard®">Villaboard®</option>
                                            <option value="10mm SHEETROCK® ONE">10mm SHEETROCK® ONE</option>
                                            <option value="13mm SHEETROCK® HD">13mm SHEETROCK® HD</option>
                                            <option value="10mm Wetstop®">10mm Wetstop®</option>
                                            <option value="13mm Wetstop®">13mm Wetstop®</option>
                                            <option value="13mm Firestop®/Fire Wetstop™">13mm Firestop®/Fire Wetstop™
                                            </option>
                                            <option value="16mm Firestop®/Fire Wetstop™">16mm Firestop®/Fire Wetstop™
                                            </option>
                                            <option value="13mm FIBEROCK®">13mm FIBEROCK®</option>
                                            <option value="16mm FIBEROCK®">16mm FIBEROCK®</option>
                                            <option value="13mm Multistop™">13mm Multistop™</option>
                                            <option value="16mm Multistop™">16mm Multistop™</option>
                                            <option value="10mm Soundstop®">10mm Soundstop®</option>
                                            <option value="13mm Soundstop®">13mm Soundstop®</option>
                                            <option value="25mm Shaftliner™ MS">25mm Shaftliner™ MS</option>
                                            <option value="12.5mm Permarock®">12.5mm Permarock®</option>
                                            <option value="6mm Villaboard®">6mm Villaboard®</option>
                                            <option value="10mm">10mm</option>
                                            <option value="13mm">13mm</option>
                                            <option value="16mm">16mm</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Ref</label>
                                        <input type="text" value={ref} required
                                               onChange={event => setRef(event.target.value)}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Side One / External</label>
                                        <input type="text" value={sideOne} required
                                               onChange={event => setSideOne(event.target.value)}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Side Two / Internal</label>
                                        <input type="text" value={sideTwo} required
                                               onChange={event => setSideTwo(event.target.value)}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Masonry / Column</label>
                                        <input type="text" value={masonry} required
                                               onChange={event => setMasonry(event.target.value)}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Insulation</label>
                                        <input type="text" value={insulation} required
                                               onChange={event => setInsulation(event.target.value)}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>R-Val</label>
                                        <input type="text" value={rval} required
                                               onChange={event => setRval(event.target.value)}/>
                                    </div>
                                </div>

                                <div className="row justify-content-center">
                                    <div className="col-6" style={{marginTop: 20}}>
                                        <button type='submit' className='btn-back-dashboard'>Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </>)
}
